import { MaintenanceStatusResponseSchema } from "@cede/types";
import { API_ENDPOINT } from "@cede/utils";
import { useMaintenanceStatusStore } from "./useMaintenanceStatusStore";
import { useApi } from "@/hooks/core/useApi";
import { useQuery } from "@tanstack/react-query";

const MAINTENANCE_STATUS_QUERY_KEY = ["maintenance-status"];

export const useMaintenanceStatus = () => {
  const { setMaintenanceMode, isMaintenanceMode } = useMaintenanceStatusStore();
  const apiHelper = useApi();

  useQuery({
    queryKey: MAINTENANCE_STATUS_QUERY_KEY,
    queryFn: async () => {
      const response = await apiHelper.getOrThrow(API_ENDPOINT.HUB_MAINTENANCE_STATUS);
      const parsedResponse = MaintenanceStatusResponseSchema.parse(response);
      setMaintenanceMode(parsedResponse.isMaintenanceMode || false || false);
      return parsedResponse;
    },
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  return {
    isMaintenanceMode,
  };
};
